window.lazySizesConfig = window.lazySizesConfig || {};
//
// // use .lazy instead of .lazyload
window.lazySizesConfig.lazyClass = 'm-lazy';
//
// // use data-original instead of data-src
lazySizesConfig.srcAttr = 'data-lazy-src';
lazySizesConfig.srcsetAttr = 'data-lazy-srcset';

// expandFct - default: 1.5
// lazySizesConfig.expFactor = 1;
lazySizesConfig.expFactor = 0.01;
//
//page is optimized for fast onload event
lazySizesConfig.loadMode = 1;
